import { render } from "./MenuItem.vue?vue&type=template&id=131bcaec&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=131bcaec&lang=scss&module=s"
cssModules["s"] = style0
import "./MenuItem.vue?vue&type=style&index=1&id=131bcaec&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-131bcaec"]])

export default __exports__